import {useCallback} from "react";
export function useNavigateTo() {
  const navigateTo = useCallback(({
    toState,
    toParams
  }) => {
    const event = new CustomEvent("navigate", {
      detail: {
        toState,
        toParams
      }
    });
    document.dispatchEvent(event);
  }, []);
  return {
    navigateTo
  };
}
